import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	noResults: {
		id: 'company-hub.cards-extension.link-cards-content.card-components.error-states.no-results.header',
		defaultMessage: 'We can’t show you this content',
		description:
			"Heading message shown when the URL we are trying to render as a smart card can't be found",
	},
	noResultsDescription: {
		id: 'company-hub.cards-extension.link-cards-content.card-components.error-states.no-results.description',
		defaultMessage: 'The content doesn’t exist or it may have changed after this link was added',
		description:
			"Describes possible action when URL we are trying to render as a smart card can't be found",
	},
});
